import { render, staticRenderFns } from "./Expert_Sharing.vue?vue&type=template&id=ef03e564&scoped=true&"
import script from "./Expert_Sharing.vue?vue&type=script&lang=js&"
export * from "./Expert_Sharing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef03e564",
  null
  
)

export default component.exports